import Pusher from "pusher-js";
import { pusherConfig } from "./config";
import { useAuthStore } from "@stores/auth/authStore";
import type { BroadcastPusherConfig } from "@lib/broadcast";

export function createPusherClient(_userId: string, broadcastPusher?: BroadcastPusherConfig) {
    const pusher = new Pusher(broadcastPusher?.key ?? pusherConfig.key, {
        cluster: broadcastPusher?.cluster ?? pusherConfig.cluster,
        authEndpoint: pusherConfig.authEndpoint,
        auth: {
            headers: {
                Authorization: `Bearer ${useAuthStore.getState().token}`,
                Accept: "application/json",
            },
        },
        forceTLS: true,
    });

    return pusher;
}

export function getNotificationChannelName(userId: string): string {
    return `private-platform.user.${userId}`;
}
